module.exports = __webpack_public_path__ + "static/media/menuConverse.285c051e.svg";